(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('ValuationApiClientDeleteController', ValuationApiClientDeleteController);

    ValuationApiClientDeleteController.$inject = ['$uibModalInstance', 'entity', 'ValuationApiClient'];

    function ValuationApiClientDeleteController($uibModalInstance, entity, ValuationApiClient) {
        var vm = this;

        vm.valuationApiClient = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ValuationApiClient.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
